/* eslint-disable import/prefer-default-export */
import axios from '@/api';

function getFamiliariMinore(id) {
  return axios.get(`tutor/family/minor/${id}`)
    .then(response => response.data)
    .catch(error => Promise.reject(error));
}

function getFamiliareCf(id, cf) {
  const data = {
    fiscal_code: cf,
  };
  return axios.post(`tutor/family/minor/${id}/search`, data)
    .then(response => response)
    .catch(error => Promise.reject(error.response));
}

function associateFamiliari(id, associate) {
  const data = {
    user: {
      email: associate.email,
      name: `${associate.name} ${associate.surname}`,
      username: associate.username,
    },
    individual: {
      name: associate.name,
      surname: associate.surname,
      fiscal_code: associate.fiscal_code,
      mobile: associate.mobile,
      phone: associate.mobile,
      show_contacts: false,
    },
    relation: {
      relative: associate.relative,
      is_admin: false, // Blocked to false
    },
  };
  return axios.post(`tutor/family/minor/${id}/associate`, data)
    .then(response => response)
    .catch(error => Promise.reject(error));
}


function associateFamiliariToMinor(id, individual, associate) {
  const data = {
    relative: associate.relative,
    is_admin: false,
  };

  return axios.post(`tutor/family/minor/${id}/individual/${individual}/associate`, data)
    .then(response => response)
    .catch(error => Promise.reject(error));
}

export const familiariService = {
  getFamiliariMinore,
  getFamiliareCf,
  associateFamiliari,
  associateFamiliariToMinor,
};
